module.exports = __webpack_public_path__ + "img/5.0e1e2c1e.png";